<script>
import { h } from 'vue'

export default {
  name: 'JbButtons',
  props: {
    noWrap: Boolean,
    type: {
      type: String,
      default: ''
    },
    classAddon: {
      type: String,
      default: ''
    },
    mb: {
      type: String,
      default: ''
    }
  },
  render () {
    const hasSlot = this.$slots && this.$slots.default

    const parentClass = [
      // 'h-full',
      'flex',
      'items-center',
      this.type,
      this.noWrap ? 'flex-nowrap gap-2' : 'flex-wrap'
    ]

    if (this.mb) {
      parentClass.push(this.mb)
    }

    return h(
      'div',
      { class: parentClass },
      hasSlot
        ? this.$slots.default().map(element => {
          if (element && element.children && typeof element.children === 'object') {
            return h(
              element,
              {},
              element.children.map(child => {
                return h(child, { class: [this.classAddon] })
              }))
          }

          return h(element, { class: [this.classAddon] })
        })
        : null
    )
  }
}
</script>
